import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import StreamsFields from './formGroup22StreamsFields';

export default {
  title: 'Ingest process configuration',
  attributeName: 'ingestProcess',
  validationUrl:'live',
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'source',
      type: FormInputTypes.SELECT,
      label: 'Source',
      default:'rtp',
      options: [
        { name: 'rtp', value: 'rtp' },
        { name: 'srt', value: 'srt' },
        { name: 'http', value: 'http' },
      ],
      helpText: 'Set the source.',
      errorText: '',
      visibleWhen:{"field":"type","value":'flat'},
    },
    {
      attributeName: 'source',
      type: FormInputTypes.SELECT,
      label: 'Source',
      default:'rtp',
      options: [
        { name: 'rtp', value: 'rtp' },
        { name: 'srt', value: 'srt' },
        { name: 'http', value: 'http' },
      ],
      helpText: 'Set the source.',
      errorText: '',
      visibleWhen:{"field":"type","value":'180'},
    },
    {
      attributeName: 'source',
      type: FormInputTypes.SELECT,
      label: 'Source',
      default:'rtp',
      options: [
        { name: 'rtp', value: 'rtp' },
        { name: 'srt', value: 'srt' },
        { name: 'http', value: 'http' },
      ],
      helpText: 'Set the source.',
      errorText: '',
      visibleWhen:{"field":"type","value":'360'},
    },
    {
      attributeName: 'source',
      type: FormInputTypes.SELECT,
      label: 'Source',
      default:'rtp',
      options: [
        { name: 'decklink', value: 'decklink' },
        { name: 'srt', value: 'srt' },
      ],
      helpText: 'Set the source.',
      errorText: '',
      visibleWhen:{"field":"type","value":'ccr'},
    },
    {
      attributeName: 'source',
      type: FormInputTypes.SELECT,
      label: 'Source',
      default:'rtp',
      options: [
        //{ name: 'rtp', value: 'rtp' },
        { name: 'decklink', value: 'decklink' },
        { name: 'srt', value: 'srt' },
      ],
      helpText: 'Set the source.',
      errorText: '',
      visibleWhen:{"field":"type","value":'controlroom'},
    },
    {
      attributeName: 'type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Camera Type',
      label: 'Camera Type',
      required: true,
      helpText: 'Set the video delay.',
      errorText: '',
      hidden:true,
    },
    // {
    //   attributeName: 'videoScale',
    //   type: FormInputTypes.TEXT_INPUT.NUMBER,
    //   placeholder: 'Video scale',
    //   label: 'Video scale',
    //   required: true,
    //   default:1,
    //   helpText: 'Set the video scale.',
    //   errorText: '',
    // },
      {
      attributeName: 'videoScale',
      label: 'Video scale',
      helpText: 'Video scale.',
      type: FormInputTypes.SELECT,
      default:'1',
      options: [
        { name: '1', value: '1' },
        { name: '0.75', value: '0.75' },
        { name: '0.50', value: '0.50' },
        { name: 'custom', value: 'custom' },
      ],
    },
    {
      attributeName: 'customVideoScale',
      label: 'Custom video scale',
      helpText: 'Select custom video scale.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      visibleWhen:{"field":"videoScale","value":"custom"},

    },
    {
      attributeName: 'videoDelay',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Video delay',
      label: 'Video delay',
      required: true,
      default:"0",
      helpText: 'Set the video delay.',
      errorText: '',
    },
    {
      attributeName: 'videoBitrate',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Video bitrate',
      label: 'Video bitrate',
      required: true,
      default:'50000',
      helpText: 'Set the video bitrate in kbps.',
      errorText: '',
    },
    {
      attributeName: 'streams',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any stream yet.",
      itemLabel:'Stream',
      columns:2,
      label: 'Streams',
      required: true,
      helpText: 'Insert new streams.',
      errorText: '',
      extraValues:['deploymentType','type','source','audioPublishID'],
      classCss:"jsonComponent__width100",
      popupFormGroups:[
        StreamsFields
      ]
    },
   
  ]
};
